import { FC } from "react"
import { SubscriptionDetails } from "../../../../../../../types"
import SectionCell from "../../../../../section/cell"
import { If } from "../../../../.."

interface Props {
  data: SubscriptionDetails
}

const PropertyLocation: FC<Props> = ({ data }) => {
  const {
    quote_info: {
      location: { state, city, county, street_address, zipcode }
    }
  } = data
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      <If
        condition={!!street_address}
        then={
          <SectionCell
            label="Street address"
            value={street_address}
            className="!pt-0"
          />
        }
      />
      <SectionCell label="City" value={city} className="!pt-0" />
      <SectionCell label="State" value={state} className="!pt-0" />
      <SectionCell label="County" value={county} className="!pt-0" />
      <SectionCell label="Zipcode" value={zipcode} className="!pt-0" />
    </div>
  )
}

export default PropertyLocation
